<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="grid-margin column mobile-full third">
                        <h4>{{ 'referral_link' | localise }}</h4>

                        <div class="ref-link">
                            https://agaia.life/<ng-container *ngIf="is_en">en/</ng-container><span class="referral-name">{{ referral_name }}</span>
                        </div>

                        <div id="social-share">
                            <nav>
                                <a (click)="changeReferralName()" class="instagram">
                                    <i class="fa fa-pencil"></i>
                                    <span>{{ 'change' | localise }}</span>
                                </a>
                                <a (click)="copyUrl()" class="copy"><i class="fa fa-link"></i><span>Copy URL</span></a>
                            </nav>
                        </div>

                        <div id="referrals-stats">
                            <table>
                                <tr>
                                    <td>
                                        <p class="stats-title">{{ 'signups' | localise }}</p>
                                        <span class="stats-number">{{ referrals_statistics.singups }}</span>
                                    </td>
                                    <td>
                                        <p class="stats-title">{{ 'paid' | localise }}</p>
                                        <span class="stats-number">{{ referrals_statistics.paid_singups }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="stats-title">{{ 'current_amount' | localise }}</p>
                                        <span class="stats-number">{{ referrals_statistics.wallet_amount | money }}</span>
                                    </td>
                                    <td>
                                        <p class="stats-title">{{ 'paid_amount' | localise }}</p>
                                        <span class="stats-number">{{ referrals_statistics.paid_wallet_amount | money }}</span>
                                    </td>
                                </tr>
                            </table>

                            <button (click)="router.navigate(['wallet'])" class="btn-wallet btn btn-sm pull-right">
                                <i class="ti-wallet"></i>
                                {{ 'wallet' | localise }}
                            </button>
                        </div>
                    </div>
                    <div class="referrals-block grid-margin column mobile-full sixfive-percentage">
                        <h4>{{ 'referrals' | localise }}</h4>

                        <ul class="referrals">
                            <li *ngFor="let referral of referrals">
                                <button class="time-field btn btn-sm btn-info pull-right">
                                    {{ formatDate(referral.created_at) }}
                                </button>
                                <button *ngIf="!referral.referral.is_wizard_complete" class="time-field additional-field btn btn-sm btn-danger pull-right">
                                    {{ 'uncomplete_signup' | localise }}
                                </button>
                                <button *ngIf="referral.referral.subscription !== null"
                                        [ngClass]="referral.referral.subscription.pricing_plan.monthly_price === '0.00' ? 'free-plan' : 'paid-plan'"
                                        class="time-field additional-field btn btn-sm pull-right">
                                    {{ referral.referral.subscription.pricing_plan.title }}
                                </button>

                                <span *ngIf="referral.referral.first_name.length > 0 && referral.referral.last_name.length > 0" class="referral-name">
                                    {{ referral.referral.first_name }} {{ referral.referral.last_name }}
                                </span>

                                <span *ngIf="!(referral.referral.first_name.length > 0 && referral.referral.last_name.length > 0)" class="referral-name">
                                    #{{ referral.referral.id }}
                                </span>
                            </li>
                        </ul>

                        <app-alerts-components
                                *ngIf="referrals.length <= 0"
                                [type]="'info'"
                                [disableClose]="true"
                                [icon]="'fa fa-exclamation-triangle'"
                                [id]="'no_referrals'"
                                [title]="'not_found_referrals_title' | localise"
                                [message]="'not_found_referrals_text' | localise"></app-alerts-components>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
